var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_234_397",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_234_397",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAE3UlEQVR4nO2dy2/cVBSHB/FcgMSmLNgE3+uoImyACKT43slseKQ8yyOCbpC6YYEUkjlnIqSqUuAP4FEJCbHmtaNsEAvYww6qCgQsWwQUUZaUpqWg40mrjOfac2c89njs3yfNZnLtsf3l3Jftc1stAAAAAAAwzEJn8/bF1c2771rhhXBt42ZHEVA0B6Pt27SlY9rSaW35v2sfQxeU4S9Umx8v/CBAn8U2r2rLvw+IcH8+l+jZ2wwUgY7oBWV510PG1Yg5JdFUyME0ldDykrJ8VFl+VRu+nLzoytJFZfgHZeisWwp/POtzqA2h5eflgrsutDJ0SRk+vtR55dar5aVx14a/SpS9ErS7D872TOoiw9CllP/6y8ryi67tlpdfvlFZ/npwG3qv/DNoigwbtw1vZG0f2N5DifI/l3f0TZNh48953d6+P20fC52dW6Sq2lf+73LPos4yDF3Qlj8cRwqEFCRDGf5HRd3H5O/a8Ou+UgJDDyfanJ+mcYzNlmHpYmDpif3lfKQsLe3cpAx9g0Z9yjJ0RE+5ymdKWV+/Xhv6ZKjbu8IPTHp8jSJ0yuBdZXrPZG2XJkUZPjn8PX1U3hnVrzd1JWh3n/PZPkVKUsZpTJ14IBc9fU6K3m61Wtf57EdZfi1Dxo8Ho+07ffbTaEKvcUYspZUrUszWPcWeSa3HGfRXHinK8AfJ7UNL68WeTW1ldNekhxT3lCaQIuOUvcHjwPgljHq6nDOrSZuhEuOMxah3r7L05zhtijJ8KCmjP/FIR0o9wTrICA0/mSw7jhSJDIkEyChIxjhS5J45ZJQgw0dK/6ZVosuMamrCiULDh1qepDf0A9Pq8Z1D+T3f/TaOIEdk+EcKIqO0yHBHyvA4BZFRYmTsJ4x6j6BrWxEZuk2PQsaYQEaFCBAZ1ZehU+70+YJqagIgo0IEiIzqEEBGA2TY7hq6tpAxvwSIjOoQQEZ1CCBjDmS0e0/n2S8acMiYbwJERnUIIKP+MhSem4KMuSZAZMyBDEuH8+wX1VTFZCg83jkNGbwLGTMAMioEZFQIyKgQkNEEGRFeloGMOkbGqAwJo0BkTABkVAjIqBCQ0QQZbbztOhUZWVk7IaNAIKNCQEaFgIwKARlzISNf9huF3lSFZBh+FrlDIGN+Uavbi8kHB+Q/Om/CFVdkKCRy8blw9JYj8co7kDEDOp2dG7Sh39xZcPjoJPtEm5EDeaEyNTXRcHacs6Oy7jjnvAzyTfkLsfSpr5C9VEhnIKMgQrtxILn+kjL8prb0b5YU174QGVNAGdpMXOzv4u8tHdGGf/UVAhlTQln6djA6eluucllCihpMNg7JNTg87tg44Co73APrviTfu7J3ogGfEEmHmmg7TqaWTVZfsviioROQMSXidfgM/zFwkTNeLYvblBENPSIjB/JU4eAFpXMiKWubfu8LMgpBGfos0X68m9otNr0tWYAXMgpCrfAdjpVnrq1CJpEi1Ze0KaNWTY6XbEDG53yElrspF/i8RIpUX6NH7HROJiRlljjn4QAZ/I0zVTLQs7L0pawqM6q9AeMlnx9LhDL0vSyMJVWd7+8AT2Ts4CcizoP+vra87LtvMAHO+x77Rur93hcdRpVUEsryL8NtA52Sri2qpBmw9zLMmThSDJ0IV+m+WRwHAAAAAAAArdz8Dw/Vp/9WjkolAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.76e90d2a6d0d44dcead0f0e7f6e24611.svg";
export { ForwardRef as ReactComponent };